import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { environment as params } from 'src/environments/environment';

@Component({
  selector: 'app-flight-multidestino',
  templateUrl: './flight-multidestino.component.html',
  styleUrls: ['./flight-multidestino.component.scss', '../../../../../../../../../assets/css/arma-ruta.css']
})
export class FlightMultidestinoComponent implements OnInit {
  @Input() initialDeparting: any;
  @Input() isMobile: boolean;
  @Input() widgetData: any;
  @Input() airportsGrp: any;
  @Input() submit: boolean;
  @Output() eventOutput: EventEmitter<any> = new EventEmitter<any>();
  urlBaseMJ: any = (<any>params).api.mj;
  public form: FormGroup;
  posicionesText = ['Primer', 'Segundo', 'Tercer', 'Cuarto', 'Quinto', 'Sexto'];
  
  constructor(
    private _f: FormBuilder
  ) {
    this.form = this._f.group({
      fMultidestino: this._f.array([this.buildMultiDestForm(0), this.buildMultiDestForm(1)])
    });
    this.form.valueChanges.subscribe(change => {
      this.eventOutput.emit(this.form);
    })
  }

  ngOnInit() {
    this.fMultidestino.controls[0].get('mOrigen').setValue(this.initialDeparting);
  }
  get fMultidestino() {
    return (this.form.controls.fMultidestino as FormArray);
  }
  buildMultiDestForm(index: number) {
    let multiForm: FormGroup = this._f.group({
      mIndex: [index, []],
      mOrigen: ['', [Validators.required]],
      mDestino: ['', [Validators.required]],
      mDate: [[], []],
      minDate: [index < 2 ? moment().add(2, 'd').toDate() : this.getMultiMinDate(index), []]
    });

    multiForm.get('mDate').valueChanges.subscribe(value => {
      const mIndex = multiForm.get('mIndex').value;
      if (value.length > 0 && this.fMultidestino.length - 1 > mIndex) {
        const newDate = moment(value[0], "DD-MM-YYYY").toDate();
        (this.form.get('fMultidestino') as FormArray).controls[mIndex + 1].get('minDate')
          .setValue(newDate);
        //-----------------------------
        // for para comprobar que las otras fechas no estes atrasadas
        this.fMultidestino.controls.forEach(mControl => {
          if (mControl.get('mIndex').value > mIndex) {
            const dateValue = mControl.get('mDate').value;
            if (dateValue.length > 0 && moment(dateValue[0], 'DD-MM-YYYY').toDate() < newDate) {
              mControl.get('mDate').setValue([]);
              mControl.get('minDate').setValue(this.getMultiMinDate(mControl.get('mIndex').value));
            }
          }
        });
        //-----------------------------
      }
    });

    multiForm.get('mDestino').valueChanges.subscribe(value => {
      const mIndex = multiForm.get('mIndex').value;
      if (typeof value === 'object' && this.fMultidestino.length - 1 > mIndex) {
        (this.form.get('fMultidestino') as FormArray).controls[mIndex + 1].get('mOrigen').setValue(value);
      }
    });

    return multiForm;
  }
  getMultiMinDate(index) {
    if (this.fMultidestino.controls[index - 1].get('mDate').value.length > 0) {
      return moment(this.fMultidestino.controls[index - 1].get('mDate').value[0], 'DD-MM-YYYY').toDate();
    } else {
      return this.fMultidestino.controls[index - 1].get('minDate').value;
    }
  }
  addMD() {
    if (this.fMultidestino.length < this.posicionesText.length) {
      (this.form.get('fMultidestino') as FormArray).push(this.buildMultiDestForm(this.fMultidestino.length));
    }
  }

  removeLastMD() {
    this.fMultidestino.removeAt(this.fMultidestino.length - 1);
  }

}
